// Mochi's Hype Meter — a 0..25 float that drains over 48 hours since the
// last feed. The meter has 5 levels:
//
//   Spark (0–4.99) → Flame (5–9.99) → Fire (10–14.99) → Blaze (15–19.99) → Inferno (20–25)
//
// Lifetime `rice_balls_fed_total` still drives the milestone tier ladder
// on the Stats jar widget — this meter is purely "current momentum".

export const METER_STEP = 5;
export const METER_MAX = 25;

export const METER_LEVELS = [
    { level: 1, name: "Hungry",   minValue: 0,  color: "sage",       tint: "bg-sage-soft/60",       fg: "text-sage" },
    { level: 2, name: "Peckish",  minValue: 5,  color: "mustard",    tint: "bg-mustard-soft/60",    fg: "text-mustard" },
    { level: 3, name: "Content",  minValue: 10, color: "terracotta", tint: "bg-terracotta-soft/60", fg: "text-terracotta" },
    { level: 4, name: "Full",     minValue: 15, color: "terracotta", tint: "bg-terracotta-soft/80", fg: "text-terracotta" },
    { level: 5, name: "Stuffed",  minValue: 20, color: "terracotta", tint: "bg-terracotta",         fg: "text-cream" },
];

export const MAX_LEVEL = METER_LEVELS.length;

export function getMochiMeter(meterValue) {
    const v = Math.max(0, Math.min(METER_MAX, meterValue || 0));
    // Find current level — tiny epsilon so values like 19.99 (which can result
    // from the backend decay-then-add math) still count as having crossed
    // the next integer threshold.
    const eps = 0.005;
    let current = METER_LEVELS[0];
    for (const lv of METER_LEVELS) {
        if (v + eps >= lv.minValue) current = lv;
    }
    const next = METER_LEVELS.find((lv) => lv.minValue > current.minValue) || null;
    const capped = !next;
    const span = next ? next.minValue - current.minValue : METER_STEP;
    const progress = capped ? 1 : Math.max(0, Math.min(1, (v - current.minValue) / span));
    const toNext = next ? Math.max(0, Math.ceil(next.minValue - v - eps)) : 0;
    return { current, next, progress, toNext, capped, value: v };
}

// Normalize meter value into a 0..1 "momentum" scalar used by the Avatar to
// scale its idle animation (faster breathing + bigger bounces at Inferno).
export function getMochiMomentum(meterValue) {
    const v = Math.max(0, Math.min(METER_MAX, meterValue || 0));
    return v / METER_MAX;
}
